import React, {Component, ReactElement, RefObject} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
    Note,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors} from '../../../styledComponents/Constants'
import {THREAD_CATEGORY, THREAD_PRIORITY} from '../../../CodeMaster'
import {Box} from '@mui/material'
import {
    getFileExtension,
    getFileIconPath,
    getThreadContributorLabelFromSession,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {PlainBackLink} from '../../../styledComponents/Links'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {PrimaryStyledButton, SecondaryButton, SmallPlainLinkStyledButton} from '../../../styledComponents/Button'
import {
    DisplayBlockDiv,
    DisplayItemDiv,
    DisplayItemInput,
    DisplayItemInputLabel,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    DisplayItemTitle,
    DisplayRadioItemLabel,
    DisplayRadioItemName,
    FieldErrorLabel,
    TitleErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {
    NatPostBulletinBoardThreadConfirm,
    NatPostBulletinBoardThreadConfirmParams,
    ThreadFile,
    ThreadImage,
} from './repository/NatPostBulletinBoardThreadConfirm'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import {Location, useLocation} from 'react-router-dom'

function withRouter<P extends object>(
    WrappedComponent: React.ComponentType<P>
): React.FC<P> {
    function RouterWrapper(props: P): JSX.Element {
        const location = useLocation();
        return <WrappedComponent{...props} location={location}/>;
    }

    return RouterWrapper;
}


interface FieldsError {
    title: Error[]
    priority: Error[]
    detail: Error[]
    threadImage: Error[]
}

interface Error {
    message: string
    hasError: boolean
}

interface ThreadFileError {
    errorKey: number
    errorMessage: string
}

type Field =
    'title'
    | 'priority'
    | 'detail'
    | 'threadImage'


interface Props {
    categoryId: string
    bulletinBoardRepo: NatBulletinBoardRepo
    location: Location<NatPostBulletinBoardThreadConfirmParams>
}


interface States {
    isLoadCompleted: boolean
    fieldsError: Partial<FieldsError>
    inputItemsTitle: string
    inputItemsThreadPriority: string
    inputItemsDetail: string
    inputItemsThreadImage: ThreadImage[]
    inputItemsThreadFile: ThreadFile[]
    selectedFileName: string
    selectedFileData: string | ArrayBuffer | null
    selectedFileSize: number
    publishFileName: string
    errorTitleMessage: string
    threadFileError: ThreadFileError[]
}

class NatResidentBulletinBoardThreadRegisterPage extends Component<Props & ResidentPagePropsSet, States> {
    threadImage: RefObject<HTMLInputElement>
    threadFile: RefObject<HTMLInputElement>
    threadConfirmParamsState: NatPostBulletinBoardThreadConfirmParams | null
    autoFocus: RefObject<HTMLInputElement>

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            fieldsError: {},
            errorTitleMessage: '',
            inputItemsTitle: '',
            inputItemsThreadPriority: THREAD_PRIORITY.NORMAL.value,
            inputItemsDetail: '',
            inputItemsThreadImage: [],
            inputItemsThreadFile: [],
            selectedFileName: '',
            selectedFileData: '',
            selectedFileSize: 0,
            publishFileName: '',
            threadFileError: [],
        }
        this.autoFocus = React.createRef()
        this.threadImage = React.createRef()
        this.threadFile = React.createRef()

        const locationState: NatPostBulletinBoardThreadConfirmParams = this.props.location.state
        this.threadConfirmParamsState = (locationState) ? locationState : null

        this.clickComfirmButton = this.clickComfirmButton.bind(this)
        this.onChangeTitle = this.onChangeTitle.bind(this)
        this.onChangeThreadPriority = this.onChangeThreadPriority.bind(this)
        this.onChangeDetail = this.onChangeDetail.bind(this)
        this.judgeConfirmButtonDisabled = this.judgeConfirmButtonDisabled.bind(this)
        this.onChangeUploadImage = this.onChangeUploadImage.bind(this)
        this.onChangePublishFileName = this.onChangePublishFileName.bind(this)
        this.deleteImage = this.deleteImage.bind(this)
        this.deleteFile = this.deleteFile.bind(this)
        this.addThreadFile = this.addThreadFile.bind(this)
        this.judgeFileAddButtonDisabled = this.judgeFileAddButtonDisabled.bind(this)
        this.onChangeUploadFile = this.onChangeUploadFile.bind(this)

    }

    async componentDidMount(): Promise<void> {
        if (this.threadConfirmParamsState) {
            const locationState: any = this.props.location?.state;
            const paramsState =
                this.threadConfirmParamsState ??
                locationState?.threadConfirmParamsState ??
                locationState ?? {};
            const actualState = (paramsState as any)?.threadConfirmParamsState ?? paramsState;
            const priority: string = actualState.priority ?? '';
            const title: string = actualState.title ?? '';
            const detail: string = actualState.detail ?? '';
            const threadImage: ThreadImage[] = actualState.threadImage ?? [];
            const threadFile: ThreadFile[] = actualState.threadFile ?? [];
            this.setState({
                inputItemsTitle: title,
                inputItemsThreadPriority: priority,
                inputItemsDetail: detail,
                inputItemsThreadImage: threadImage,
                inputItemsThreadFile: threadFile,
                isLoadCompleted: true,
            })
        } else {
            this.setState({isLoadCompleted: true})
        }

    }

    judgeConfirmButtonDisabled(): boolean {
        return !(this.state.inputItemsTitle &&
            this.state.inputItemsThreadPriority &&
            this.state.inputItemsDetail)
    }

    judgeFileAddButtonDisabled(): boolean {
        return !(this.state.selectedFileName &&
            this.state.publishFileName) || (this.state.inputItemsThreadFile.length >= 3)
    }

    onClickInputFile(elementId: string): void {
        const fileUpload = document.getElementById(elementId) as HTMLInputElement
        fileUpload.value = ''
        if (fileUpload) {
            fileUpload.click()
        }
    }

    onChangeUploadImage(event: React.ChangeEvent<HTMLInputElement>): void {
        // 画像情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            const reader: FileReader = new FileReader()
            const inputItemsThreadImage = this.state.inputItemsThreadImage
            const selectedThreadImage: ThreadImage =
                {fileName: event.target.files[0].name, fileSize: event.target.files[0].size, fileData: ''}
            reader.onload = () => {
                selectedThreadImage.fileData = reader.result
                inputItemsThreadImage.push(selectedThreadImage)
                this.setState({inputItemsThreadImage: inputItemsThreadImage})
                // 追加したタイミングで選択した画像をクリア
                if (this.threadImage.current && this.threadImage.current.value) {
                    this.threadImage.current.value = ''
                }
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }


    onChangeUploadFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {

            this.setState({
                selectedFileName: event.target.files[0].name,
                selectedFileSize: event.target.files[0].size,
            })

            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({selectedFileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }

    onChangeUploadFileSortOrder = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputItemsThreadFile = this.state.inputItemsThreadFile
        inputItemsThreadFile[index].sortOrder = Number(event.target.value)
        this.setState({inputItemsThreadFile: inputItemsThreadFile})
    }

    deleteImage(index: number): void {
        const inputItemsThreadImage = this.state.inputItemsThreadImage
        inputItemsThreadImage.splice(index, 1)
        this.setState({inputItemsThreadImage: inputItemsThreadImage})
    }

    deleteFile(index: number): void {
        const inputItemsThreadFile = this.state.inputItemsThreadFile
        inputItemsThreadFile.splice(index, 1)
        const threadFileError = this.state.threadFileError
        threadFileError.splice(index, 1)
        this.setState({
            inputItemsThreadFile: inputItemsThreadFile,
            threadFileError: threadFileError,
        })
    }

    onChangePublishFileName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({publishFileName: event.target.value})
    }

    addThreadFile(): void {
        const inputItemsThreadFile = this.state.inputItemsThreadFile
        const threadFile: ThreadFile = {
            ['sortOrder']: inputItemsThreadFile.length + 1,
            ['fileName']: this.state.selectedFileName,
            ['fileSize']: this.state.selectedFileSize,
            ['fileData']: this.state.selectedFileData,
            ['publishFileName']: this.state.publishFileName,
        }
        inputItemsThreadFile.push(threadFile)
        this.setState({
            selectedFileName: '',
            selectedFileSize: 0,
            selectedFileData: '',
            publishFileName: '',
            inputItemsThreadFile: inputItemsThreadFile,
        })

        // 追加したタイミングで選択したファイルをクリア
        if (this.threadFile.current && this.threadFile.current.value) {
            this.threadFile.current.value = ''
        }
    }

    async clickComfirmButton(): Promise<void> {

        await this.clearMessage()
        await this.props.eventEmitter.showLoading()
        try {

            const inputItemsThreadImage: ThreadImage[] = []
            if (this.state.inputItemsThreadImage) {
                this.state.inputItemsThreadImage.map((image) => {
                    if (image.fileData) {
                        const fileData: string[] = String(image.fileData).split(',')
                        if (fileData[1]) {
                            inputItemsThreadImage.push({
                                fileName: image.fileName,
                                fileData: fileData[1],
                                fileSize: image.fileSize,
                            })
                        }

                    }
                })
            }

            const inputItemsThreadFile: ThreadFile[] = []
            if (this.state.inputItemsThreadFile) {
                this.state.inputItemsThreadFile.forEach((file, index) => {
                    if (file.fileData) {
                        const fileData: string[] = String(file.fileData).split(',')
                        if (fileData[1]) {
                            inputItemsThreadFile.push({
                                sortOrder: file.sortOrder,
                                publishFileName: file.publishFileName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            })
                        }

                    }
                })
            }

            const request: NatPostBulletinBoardThreadConfirmParams = {
                categoryId: this.props.categoryId,
                priority: this.state.inputItemsThreadPriority,
                title: this.state.inputItemsTitle,
                detail: this.state.inputItemsDetail,
                threadImage: inputItemsThreadImage,
                threadFile: inputItemsThreadFile,
            }

            const ret: Nullable<NatPostBulletinBoardThreadConfirm> =
                await NatAsyncCallFunction(this.props.bulletinBoardRepo.postBulletinBoardThreadConfirm.bind(
                    this.props.bulletinBoardRepo, request), this.props.navigate)

            if (!ret) {
                return
            }

            // 引継ぎ情報
            this.threadConfirmParamsState = {
                categoryId: this.props.categoryId,
                priority: this.state.inputItemsThreadPriority,
                title: this.state.inputItemsTitle,
                detail: this.state.inputItemsDetail,
                threadImage: this.state.inputItemsThreadImage,
                threadFile: this.state.inputItemsThreadFile,
            }

            this.props.navigate(
                `/resident/bulletinBoardThreadConfirm`,
                {state: this.threadConfirmParamsState},
            )

        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        item.fields.forEach((field) => {
                            if (field.startsWith('threadFile')) {
                                const workFileNumber = field.split('[')[1]
                                const fileNumber = workFileNumber.split(']')[0]
                                const threadFileError: ThreadFileError[] = this.state.threadFileError
                                threadFileError[Number(fileNumber)] =
                                    {errorKey: Number(fileNumber), errorMessage: item.message}
                                this.setState({threadFileError: threadFileError})
                            } else {
                                this.setFieldErrorMessage(field, item.message)
                            }

                        })
                    }
                    if (item.resultCode === 'threadImage') {
                        this.setFieldErrorMessage('threadImage', item.message)
                    }
                    if (item.resultCode.startsWith('threadFile')) {
                        for (const file of item.resultCode) {
                            const workFileNumber = item.resultCode.split('[')[1]
                            const fileNumber = workFileNumber.split(']')[0]
                            const threadFileError: ThreadFileError[] = this.state.threadFileError
                            threadFileError[Number(fileNumber)] =
                                {errorKey: Number(fileNumber), errorMessage: item.message}
                            this.setState({threadFileError: threadFileError})
                        }
                    }
                })
                if (errorResponseBody.requestError !== null) {
                    this.setTitleErrorMessage(errorResponseBody.requestError.message)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    onChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemsTitle: event.target.value})
    }

    onChangeThreadPriority(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemsThreadPriority: event.target.value})
    }

    onChangeDetail(value: string): void {
        this.setState({inputItemsDetail: value})
    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field[0] !== undefined && field[0].hasError)
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <>
                    {field.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }
    }

    // メッセージ取得（タイトル）
    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.errorTitleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.errorTitleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    setTitleErrorMessage(message: string): void {
        this.setState({errorTitleMessage: message})
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        if (field === 'title' || field === 'priority' ||
            field === 'detail' || field === 'threadImage') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, hasError: true}]
            } else {
                error.push({message: message, hasError: true})
            }
            this.setState(({fieldsError}) => (
                {
                    fieldsError: {
                        ...fieldsError,
                        [field]: error,
                    },
                }))
        }
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {}, errorTitleMessage: '', threadFileError: []})
    }

    renderThreadFileErrorMessage(fileKey: number): Nullable<ReactElement> {
        if (this.state.threadFileError[fileKey]) {
            return (
                <FieldErrorLabel key={`threadFileError_${fileKey}`}>
                    {this.state.threadFileError[fileKey].errorMessage}
                </FieldErrorLabel>
            )
        } else {
            return (<></>)
        }
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        let subTitle: string = ''
        const locationState: any = this.props.location?.state;
        const categoryId: string | undefined = this.props.categoryId;
        const threadCategoryCode: THREAD_CATEGORY =
            THREAD_CATEGORY.codeToEnumConstants(categoryId ?? '0')
        if (threadCategoryCode) {
            subTitle = threadCategoryCode.label
        }

        return <>
            <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
            <ContentsSubTitleWrapper>
                <ContentsSubTitleInner>
                    {subTitle}
                </ContentsSubTitleInner>
            </ContentsSubTitleWrapper>

            <MainContainer>
                <DisplayItemTitle>スレッド作成</DisplayItemTitle>
                {this.getTitleErrorMessage()}
                <BlockSpacer height={'20px'}/>
                <DisplayBlockDiv>
                    <DisplayItemInputLabelRequired>
                        <DisplayItemInputTitleRequired>タイトル</DisplayItemInputTitleRequired>
                        <DisplayItemInput
                            type="text"
                            id="title"
                            name="title"
                            maxLength={50}
                            value={this.state.inputItemsTitle}
                            onChange={this.onChangeTitle}
                            hasError={this.getFieldErrorStatus('title')}
                            ref={this.autoFocus}
                        />
                    </DisplayItemInputLabelRequired>
                    {this.getFieldErrorMessage('title')}
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>名前</DisplayItemInputLabel>
                    <Box mb={'8px'}></Box>
                    <DisplayItemDiv>{getThreadContributorLabelFromSession()}</DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabelRequired>
                        <DisplayItemInputTitleRequired>優先度</DisplayItemInputTitleRequired>
                        {THREAD_PRIORITY.values().map((threadPriority, index) => (
                            <DisplayRadioItemLabel key={index}>
                                <DisplayRadioItemNamePaddingRight>
                                    <input type="radio"
                                           name={'threadPriority'}
                                           value={threadPriority.value}
                                           checked={(threadPriority.value === this.state.inputItemsThreadPriority)}
                                           onChange={this.onChangeThreadPriority}/>
                                    {threadPriority.label}
                                </DisplayRadioItemNamePaddingRight>
                            </DisplayRadioItemLabel>

                        ))}
                    </DisplayItemInputLabelRequired>
                    {this.getFieldErrorMessage('priority')}
                </DisplayBlockDiv>


                <DisplayBlockDiv>
                    <DisplayItemInputLabelRequired>
                        <DisplayItemInputTitleRequired>詳細</DisplayItemInputTitleRequired>
                        <EditorStyleDiv hasError={this.getFieldErrorStatus('detail')}>
                            <PPHtmlEditor
                                init={{
                                    maxLength: 2000,
                                }}
                                onEditorChange={this.onChangeDetail}
                                value={this.state.inputItemsDetail ? this.state.inputItemsDetail : ''}
                            />
                        </EditorStyleDiv>
                    </DisplayItemInputLabelRequired>
                    {this.getFieldErrorMessage('detail')}
                </DisplayBlockDiv>


                <DisplayBlockDiv>
                    <DisplayItemInputLabel>画像</DisplayItemInputLabel>
                    <BlockSpacer height={'8px'}/>
                    <SecondaryButton onClick={() => this.onClickInputFile('imageUpload')}
                                     disabled={(this.state.inputItemsThreadImage?.length ?? 0) >= 4}>
                        画像を選択
                    </SecondaryButton>
                    <DisplayNoneInput type={'file'} id={'imageUpload'} ref={this.threadImage}
                                      accept={'image/jpeg,image/png,image/gif'}
                                      onChange={this.onChangeUploadImage}/>
                    {this.getFieldErrorMessage('threadImage')}
                    <Note>※5MBまで</Note>

                    {(this.state.inputItemsThreadImage?.length ?? 0) > 0 ?
                        this.state.inputItemsThreadImage.map((threadImage, index) => (
                            <DisplayItemImageDiv key={`threadImage_${index}_${threadImage.fileName}`}>
                                <ThreadImgDiv>
                                    <ThreadImg src={String(threadImage.fileData)}
                                               alt={threadImage.fileName}/>
                                </ThreadImgDiv>
                                <ThreadImgDeleteDiv>
                                    <SmallPlainLinkStyledButton onClick={() => this.deleteImage(index)}>
                                        削除
                                    </SmallPlainLinkStyledButton>
                                </ThreadImgDeleteDiv>
                            </DisplayItemImageDiv>
                        )) : <></>
                    }
                </DisplayBlockDiv>


                <DisplayBlockDiv>
                    <DisplayItemInputLabel>ファイル</DisplayItemInputLabel>
                    <BlockSpacer height={'8px'}/>
                    <DisplayItemDiv>ファイル名</DisplayItemDiv>
                    <BlockSpacer height={'8px'}/>
                    <DisplayItemInput
                        type="text"
                        id="publishFileName"
                        name="publishFileName"
                        accept={'application/vnd.ms-PowerPoint,application/vnd.ms-excel,application/msword,application/pdf'}
                        maxLength={50}
                        value={this.state.publishFileName}
                        onChange={this.onChangePublishFileName}
                        disabled={(this.state.inputItemsThreadFile?.length ?? 0) >= 3}
                    />
                    <Box mb={'8px'}></Box>
                    <SecondaryButton
                        onClick={() => this.onClickInputFile('fileUpload')}
                        disabled={(this.state.inputItemsThreadFile?.length ?? 0) >= 3}>
                        ファイルを選択
                    </SecondaryButton>
                    <DisplayNoneInput type={'file'} id={'fileUpload'} ref={this.threadFile}
                                      onChange={this.onChangeUploadFile}/>
                    <DisplayItemSelectedFileName>{this.state.selectedFileName}</DisplayItemSelectedFileName>
                    <Note>※5MBまで</Note>
                    <Note>
                        ※特定のファイル形式(.docx/.xlsx/.pptx/.pdf)以外は、アップロード出来ません。
                    </Note>
                    <Note>
                        ※Word、Excel、PPTファイルを投稿した場合、ご利用の端末によっては開けない場合がございます。
                    </Note>
                    <Box mb={'8px'}></Box>
                    <SecondaryButton onClick={this.addThreadFile} disabled={this.judgeFileAddButtonDisabled()}>
                        ファイルを追加
                    </SecondaryButton>

                    {(this.state.inputItemsThreadFile?.length ?? 0) > 0 ?
                        this.state.inputItemsThreadFile.map((threadFile, index) => (
                            <ThreadFileDiv key={`threadFile${index}_${threadFile.fileName}`}>
                                <DisplayItemFileDiv>
                                    <FileIcon src={getFileIconPath(getFileExtension(threadFile.fileName))}
                                              alt={threadFile.fileName}/>
                                    <DisplayItemFileInfosDiv>
                                        <DisplayItemFileNameDiv>{threadFile.publishFileName}</DisplayItemFileNameDiv>
                                        <DisplayItemNonFileNameDiv>
                                            <DisplayItemFileSortOrderLabelDiv>並び順</DisplayItemFileSortOrderLabelDiv>
                                            <DisplayItemFileSortOrderDiv>
                                                <DisplayItemInput
                                                    type="number"
                                                    min={1}
                                                    max={999}
                                                    id={`inputItemsThreadFile_${index}`}
                                                    name={`inputItemsThreadFile_${index}`}
                                                    maxLength={3}
                                                    value={threadFile.sortOrder}
                                                    onChange={this.onChangeUploadFileSortOrder(index)}
                                                />
                                            </DisplayItemFileSortOrderDiv>
                                            <DisplayItemFileDeleteDiv>
                                                <SmallPlainLinkStyledButton onClick={() => this.deleteFile(index)}>
                                                    削除
                                                </SmallPlainLinkStyledButton>
                                            </DisplayItemFileDeleteDiv>
                                        </DisplayItemNonFileNameDiv>
                                    </DisplayItemFileInfosDiv>
                                </DisplayItemFileDiv>
                                {this.renderThreadFileErrorMessage(index)}
                            </ThreadFileDiv>
                        )) : <></>
                    }
                </DisplayBlockDiv>


            </MainContainer>
            <Box padding={'8px 0 15px 0'}>
                {Messages.INTFC0001.toString(HKConstants.VMN.NTF.THREAD_RETENTION_YEAR)}
            </Box>
            <Box mb={'15px'}>
                <PrimaryStyledButton
                    onClick={this.clickComfirmButton}
                    disabled={this.judgeConfirmButtonDisabled()}>
                    スレッド内容を確認する
                </PrimaryStyledButton>
            </Box>
            <PlainBackLink to={`/resident/bulletinBoardThreadList/${this.props.categoryId}`}>
                スレッド一覧へ戻る
            </PlainBackLink>
        </>
    }
}

export default createResidentPage(withRouter(NatResidentBulletinBoardThreadRegisterPage))

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
    content: "\f111";
  }
`

const DisplayNoneInput = styled.input`
  display: none;
`

const DisplayItemImageDiv = styled(DisplayItemDiv)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DisplayItemSelectedFileName = styled(DisplayItemDiv)`
  color: grey;
  margin: 8px 0;
`

const ThreadImgDiv: StyledDiv = styled.div`
  flex-basis: 50%;
`

const ThreadImg: StyledImg = styled.img`
  max-width: 100%;
  max-height: 30vh;
`

const FileIcon: StyledImg = styled.img`
  ${breakPoint.lessThan('sp')`
    max-width: 150%;
  `}
`

const ThreadImgDeleteDiv: StyledDiv = styled.div`
  flex-basis: 50%;
  text-align: center;
`

const DisplayItemFileDiv = styled(DisplayItemDiv)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DisplayItemFileIconDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    margin-left: 0;
  `}
`

const DisplayItemFileNameDiv = styled(DisplayItemDiv)`
  flex-basis: 50%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
  `}
`

const DisplayItemFileSortOrderLabelDiv = styled(DisplayItemDiv)`
  flex-basis: 60%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 40%;
  `}
`

const DisplayItemFileSortOrderDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 40%;
  `}
`

const DisplayItemFileDeleteDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  text-align: center;
  ${breakPoint.lessThan('sp')`
    flex-basis: 20%;
  `}
`

const DisplayRadioItemNamePaddingRight = styled(DisplayRadioItemName)`
  padding-right: 15px;
`

const DisplayItemFileInfosDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center ${breakPoint.lessThan('sp')`
    flex-direction: column;
    padding-left: 10px;
    align-items: flex-start;
  `}
`

const DisplayItemNonFileNameDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const ThreadFileDiv: StyledDiv = styled.div`
`

interface InputThreadErrorProps {
    hasError?: Nullable<boolean>;
}

const EditorStyleDiv = styled.div<InputThreadErrorProps>`
  ${props => props.hasError === true ? `border: ${Colors.Alert} 1px solid` : ``};

  & .tox-edit-area__iframe {
    ${props => props.hasError === true ? `background-color: rgba(215, 55, 74, 0.05) !important` : ``};
  }
`
